<template>
  <div style="padding-top: 20px">

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="deleteSectionVisible"
      width="30%">
      <span> 是否删除科室 <b>{{ deleteSection.name + '(' + deleteSection.sectionDirector + ')' }}</b> ？ </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="deleteSectionVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="sureDeleteSection(deleteSection)"
                   :loading="sureLoading">确 定
        </el-button>
      </span>
    </el-dialog>

    <div class="sectionDialog">
      <el-dialog top='0' :close-on-click-modal="false" :visible.sync="isDialogShow" class="spec-dialog">
        <div class="dialog-title" slot="title">
          <template> {{ section.sectionId == null ? '填写科室信息' : '修改科室信息' }}</template>
        </div>
        <el-form :model="section" label-width="100px" :rules="sectionRules" ref="sectionForm">
          <el-form-item label="科室名" prop="name">
            <el-input v-model="section.name" type="text" placeholder="请输入科室名"/>
          </el-form-item>
          <el-form-item label="科主任" prop="sectionDirector">
            <el-input v-model="section.sectionDirector" type="text" placeholder="请输入科主任姓名"/>
          </el-form-item>
          <el-form-item label="是否重点学科">
            <el-switch style="float: left;height: 40px"
                       v-model="keyDiscipline"
                       active-text="重点学科">
            </el-switch>
          </el-form-item>
          <el-form-item label="学科级别">
            <el-input v-model="section.disciplineLevel" placeholder="学科级别" type="text"/>
          </el-form-item>
          <el-form-item label="是否重点专科">
            <el-switch style="float: left;height: 40px"
                       v-model="keySpecialty"
                       active-text="重点专科">
            </el-switch>
          </el-form-item>
          <el-form-item label="专科级别">
            <el-input v-model="section.specialtyLevel" type="text" placeholder="专科级别"/>
          </el-form-item>
          <el-form-item label="普通床位数">
            <el-input-number style="width: 100%"
                             :min="0" :max="2147483647"
                             :controls="false"
                             v-model="section.generalBedNumber"
                             type="text"
                             placeholder="请输入普通床位数"/>
          </el-form-item>
          <el-form-item label="合计床位数">
            <el-input-number style="width: 100%"
                             :min="0" :max="2147483647"
                             :controls="false"
                             v-model="section.totalBedNumber"
                             type="text"
                             placeholder="请输入总床位数"/>
          </el-form-item>
          <el-form-item label="医生人数">
            <el-input-number style="width: 100%"
                             :min="0" :max="2147483647"
                             :controls="false"
                             v-model="section.doctorNumber"
                             type="text"
                             placeholder="请输入医生人数"/>
          </el-form-item>
          <el-form-item label="护士人数">
            <el-input-number style="width: 100%"
                             :min="0" :max="2147483647"
                             :controls="false"
                             v-model="section.nurseNumber"
                             placeholder="请输入护士人数"/>
          </el-form-item>
          <el-form-item label="技师人数">
            <el-input-number style="width: 100%"
                             :min="0" :max="2147483647"
                             :controls="false"
                             v-model="section.technicianNumber"
                             type="text"
                             placeholder="请输入技师人数"/>
          </el-form-item>
          <el-form-item label="房间数">
            <el-input-number style="width: 100%"
                             :min="0" :max="2147483647"
                             :controls="false"
                             v-model="section.roomNumber"
                             type="text"
                             placeholder="请输入房间数"/>
          </el-form-item>
          <el-form-item label="科室简介">
            <el-input
              placeholder="输入科室简介"
              type="textarea"
              maxlength="500"
              rows="6"
              show-word-limit
              v-model="section.intro"/>
          </el-form-item>
        </el-form>
        <template slot="footer">
          <el-button @click="isDialogShow=false" type="info" size="small">取消</el-button>
          <el-button @click="sectionCommit('sectionForm')"
                     size="small" type="primary" :loading="sureLoading">
            {{ section.sectionId == null ? '添加' : '修改' }}
          </el-button>
        </template>
      </el-dialog>
    </div>

    <div>
      <el-row>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-weight: bolder;float: left">科室信息</span>
              <el-button type="primary" style="float: right;margin-right: 1%" size="small" @click="addSection">
                添加科室
              </el-button>
              <el-button type="primary" style="float:right;margin-right: 1%;margin-left: 0" size="small"
                         @click="reSort">
                {{ dragAble ? '提交排序' : '重新排序' }}
              </el-button>
              <el-button v-show="dragAble" type="info" style="float:right;margin-right: 1%" size="small"
                         @click="cancelSortClick">
                取消排序
              </el-button>
            </div>

            <draggable :disabled="!dragAble" v-model="sections" chosen-class="chosen"
                       force-fallback="true"
                       group="people" animation="200"
                       @start="onStart" @end="onEnd">

              <div
                class="item" :class="sectionCard" v-for="section in sections"
                :key="section.sectionId" @click="sectionCard=''">
                <el-card shadow="hover" :class="sectionCardClass" :body-style="{ padding: '0px' }">
                  <div @click.stop="mouseUpHandler(section)"
                       style="margin: 8px 20px 20px;height: 100px;position:relative;overflow: hidden">
                    <div>
                      <div class="sectionDirector">
                        <span>{{ section.name + '（' + section.sectionDirector + '）' }}</span>
                      </div>
                      <div class="clearfix sectionIntro">
                        {{ section.intro }}
                      </div>
                    </div>
                    <div class="operationDiv">
                      <el-button type="text" class="button operationBtn"
                                 @click.stop="mouseUpHandler(section)">
                        查看
                      </el-button>
                      <el-button type="text" class="button operationBtn"
                                 @click.stop="editHandler(section)">
                        编辑
                      </el-button>
                      <el-button type="text" class="button operationBtn"
                                 @click.stop="deleteHandler(section)">
                        删除
                      </el-button>
                    </div>
                  </div>
                </el-card>
              </div>
            </draggable>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="sectionDialog">
      <el-dialog title="科室详细信息" class="spec-dialog" top='0' :visible.sync="showSectionInfoVisible">
        <el-form class="text infoItem" :model="section" inline>
          <el-row>
            <el-col :offset="1" :span="21">
              <el-form-item class="text-input" label="科室名">
                <el-input disabled v-model="section.name" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="1" :span="21">
              <el-form-item class="text-input" label="科主任">
                <el-input disabled v-model="section.sectionDirector" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="1" :span="10">
              <el-form-item class="text-input" :label="keyDiscipline?'重点学科':'非重点学科'">
                <el-input disabled v-model="section.disciplineLevel" placeholder="学科级别" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="10">
              <el-form-item class="text-input" :label="keySpecialty?'重点专科':'非重点专科'">
                <el-input disabled v-model="section.specialtyLevel" placeholder="学科级别" type="text"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>

          </el-row>
          <el-row>
            <el-col :offset="1" :span="10">
              <el-form-item label="普通床位数">
                <el-input class="text-input" disabled v-model="section.generalBedNumber"/>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="10">
              <el-form-item label="合计床位数">
                <el-input class="text-input" disabled v-model="section.totalBedNumber"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="1" :span="10">
              <el-form-item label="医生人数">
                <el-input class="text-input" disabled v-model="section.doctorNumber"/>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="10">
              <el-form-item label="护士人数">
                <el-input class="text-input" disabled v-model="section.nurseNumber"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="1" :span="10">
              <el-form-item label="技师人数">
                <el-input class="text-input" disabled v-model="section.technicianNumber"/>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="10">
              <el-form-item label="房间数">
                <el-input class="text-input" disabled v-model="section.roomNumber"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="1" :span="23">
              <el-form-item label="科室简介">
                <span style="width: 90%">
                  {{ section.intro }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="info" @click="editHandler(section)">修 改</el-button>
          <el-button size="small" type="primary" @click="showSectionInfoVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>


  </div>
</template>

<script>
import 'animate.css';
import draggable from 'vuedraggable'
import {Message} from "element-ui";
import cookie from "@/utils/cookie";
import http from "@/utils/axios";

export default {
  name: "SectionInfo",
  components: {
    draggable,
  },
  data() {
    return {
      //科室操作权限
      flag: false,
      //拖动的是否启用
      dragAble: false,
      showSectionInfoVisible: false,
      sectionRules: {
        name: [
          {required: true, message: '请输入科室名称', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 32 个字符之内', trigger: 'blur'}
        ],
        sectionDirector: [
          {required: true, message: '请输入科主任名称', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 50 个字符之内', trigger: 'blur'}
        ],
      },
      deleteSectionVisible: false,
      //卡片的状态 true是代表正在拖动 false没有拖动
      drag: false,
      deptId: "",
      sectionCard: 'animate__animated animate__zoomInDown',
      sectionCardClass: "sectionCardNormal",
      sureLoading: false,
      isDialogShow: false,
      keySpecialty: false,
      keyDiscipline: false,
      deleteSection: {},
      updateSection: {},
      sections: [],
      //副本
      copySections: [],
      section: {
        name: "",
        isKeyDiscipline: "0",
        disciplineLevel: "",
        isKeySpecialty: "0",
        specialtyLevel: "",
        sectionDirector: "",
        generalBedNumber: "",
        totalBedNumber: "",
        doctorNumber: "",
        nurseNumber: "",
        technicianNumber: "",
        roomNumber: "",
        intro: "",
      }
    }
  },

  created() {

  },

  watch: {
    'section.isKeyDiscipline': {
      handler(newName) {
        this.keyDiscipline = newName === "1"
      },
      deep: true,
      immediate: true
    },
    'section.isKeySpecialty': {
      handler(newName) {
        this.keySpecialty = newName === "1"
      },
      deep: true,
      immediate: true
    },

    'keyDiscipline': {
      handler(newName) {
        newName ? this.section.isKeyDiscipline = "1" : this.section.isKeyDiscipline = "0"
      },
      immediate: true
    },
    'keySpecialty': {
      handler(newName) {
        newName ? this.section.isKeySpecialty = "1" : this.section.isKeySpecialty = "0"
      },
      immediate: true
    }
  },

  methods: {

    mouseUpHandler(section) {
      if (!this.drag) {
        this.section = section
        this.showSectionInfoVisible = true
      }
    },

    sureDeleteSection(section) {
      this.sureLoading = true
      let data = {
        token: cookie.getCookie("token"),
        data: {
          sectionId: section.sectionId
        }
      }
      http.post(window.config.api.baseUrl + '/eims-api/section/delete', data).then(value => {
        if (value.data.code === '00000') {
          let index = this.sections.indexOf(section)
          this.sections.splice(index, 1)
          let copyIndex = -1
          for (let i = 0; i < this.sections.length; i++) {
            for (let j = 0; j < this.copySections.length; j++) {
              if (this.sections[i].sectionId === this.copySections[j].sectionId) {
                copyIndex = j
              }
            }
            if (copyIndex !== -1) {
              break
            }
          }
          this.copySections.splice(copyIndex, 1)
          Message.success({message: "科室删除成功", showClose: true})
        }
      }).finally(() => {
        this.deleteSectionVisible = false
        this.sureLoading = false
      })
    },

    //删除
    deleteHandler(section) {
      this.deleteSection = section
      this.deleteSectionVisible = true
    },

    //编辑
    editHandler(section) {
      this.showSectionInfoVisible = false
      this.section = JSON.parse(JSON.stringify(section))
      this.isDialogShow = true

    },

    //获取科室的操作权限
    getSectionOptPower(flag) {
      this.flag = flag
    },

    //查询科室的信息
    sectionList(deptId) {
      if (deptId == null || deptId == '') {
        return
      }
      this.deptId = deptId
      let data = {
        token: cookie.getCookie("token"),
        data: {
          departmentId: deptId
        }
      };
      http.post(window.config.api.baseUrl + '/eims-api/section/list', data).then(value => {
        if (value.data.code === '00000') {
          this.sections = value.data.data.sections
        }
      }).finally(() => {
        this.sureLoading = false
      })
    },

    //点击拖动卡片
    onStart() {
      //动画
      this.sectionCard = ''
      //拖动状态
      this.drag = true;
    },
    onEnd() {
      this.drag = false;
    },

    cancelSortClick() {
      //将原来提交修改之前的数据重新写回
      this.sections = this.copySections
      this.cancelSort()
    },

    //取消排序
    cancelSort() {
      //取消排序的样式
      this.sectionCardClass = "sectionCardNormal"
      this.dragAble = false
    },

    //重新排序
    reSort() {

      //提交排序
      if (this.dragAble) {
        if ((this.section) && this.sections.length !== 0){
          let data = {
            token: cookie.getCookie("token"),
            data: {
              "sections": this.sections,
            }
          }
          http.post(window.config.api.baseUrl + '/eims-api/section/batchUpdate', data).then(value => {
            if (value.data.code === '00000') {
              Message.success({message: "科室排序完成", showClose: true})
            }
          }).finally(() => {
            //提交之后删除副本数据
            this.copySections = []
            //取消排序的样式
            this.sectionCardClass = "sectionCardNormal"
          })
        }
        //启用排序
      } else {
        //设置可以拖动的排序样式
        this.sectionCardClass = "sectionCardMove";
        let objStr = JSON.stringify(this.sections)
        this.copySections = JSON.parse(objStr)
      }
      this.dragAble = !this.dragAble
    },

    addSection() {
      //设置如果是上一次打开时是编辑,这次打开新增则将期数据清空
      //如果上一步是点击新增,这一步打开时不清空数据
      if (this.section.sectionId) {
        this.section = {}
      }
      this.isDialogShow = true

    },

    sectionCommit(formName) {
      let flag = false;
      //validate触发检验
      this.$refs[formName].validate((valid) => {
        flag = valid;
      });
      if (!flag) {
        return
      }

      //设置部门的id
      this.section.departmentId = this.deptId
      if (!this.section.sectionId) {
        //科室编号为空则是新增科室信息
        this.createCommit()
      } else {
        //科室编号不为空则是修改科室的信息
        this.updateCommit()
      }
    },

    createCommit() {
      this.isDialogShow = false
      this.sectionCard = 'animate__animated animate__zoomInDown'
      this.sureLoading = true
      let data = {
        token: cookie.getCookie("token"),
        data: {
          ...this.section
        }
      };

      http.post(window.config.api.baseUrl + '/eims-api/section/create', data).then(value => {
        if (value.data.code === '00000') {
          Message.success({message: "科室信息添加成功", showClose: true})
          this.sections.unshift(
            value.data.data.section
          )
          this.section = {}
        }
      }).finally(() => {
        this.sureLoading = false
      })
    },

    updateCommit() {
      this.sureLoading = true
      let data = {
        token: cookie.getCookie("token"),
        data: {
          ...this.section
        }
      };

      http.post(window.config.api.baseUrl + '/eims-api/section/update', data).then(value => {
        if (value.data.code === '00000') {
          Message.success({message: "科室信息修改成功", showClose: true})
          for (let i = 0; i < this.sections.length; i++) {
            if (this.sections[i].sectionId === this.section.sectionId) {
              this.sections[i] = this.section
              break
            }
          }
        }
      }).finally(() => {
        this.sureLoading = false
        this.isDialogShow = false
      })
    }


  }
}
</script>


<style scoped>

.text {
  font-size: 14px;
}

.item {
  text-align: left;
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 100%;
  border-radius: 10px
}

.item {
  width: 50%;
  display: inline-block;
  float: left;

}

.item:nth-child(even) {
  padding: .5% 1% 0 .5%;
}

.item:nth-child(odd) {
  padding: .5% 1% 0 .5%;

}

/deep/ .spec-dialog .el-dialog__body {
  overflow-y: auto;
  height: calc(100vh - 200px);

}

/*仅限科室的弹出框的需要*/
.sectionDialog > .el-dialog__wrapper {
  overflow: hidden !important;
  top: auto !important;
}

.el-dialog {
  position: absolute;
  left: calc(50% - 400px);
  top: calc(50% - 242px);
  overflow: hidden;
  transition: all 1s;
}

.text {
  font-size: 14px;
}

.infoItem {
  text-align: left;
  margin-bottom: 18px;
}

.sectionCardNormal {
  box-shadow: #efefef 1px 1px 8px 1px;
  cursor: pointer;
}

.sectionCardMove {
  box-shadow: #efefef 1px 1px 8px 1px;
  cursor: move;
}

/deep/ .el-input.is-disabled .el-input__inner {
  border: 0px solid transparent;
  background-color: transparent;
  color: #606266;
  cursor: default;
  padding: 0;
  border-radius: 0px;

}

.operationTip {
  font-weight: bold;
  font-size: 20px;
  color: #5ed5d9;
  position: absolute;
  top: 0px;
  right: 0px;
  width: 20px;
  height: 100px;
  align-items: center;
  display: flex;
}

.operationDiv {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 50px;
}

.operationBtn {
  float: right;
  height: 33px
}

.sectionDirector {
  line-height: 18px;
  margin-right: 50px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sectionIntro {
  text-overflow: ellipsis;
  color: #9195A3;
  margin-right: 30px;
  margin-bottom: 10px;
  height: 82%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/section/SectionInfo.vue